<template>
  <!-- Back to top -->
  <a href="#" @click="topFunction" id="back-to-top"
    class="back-to-top fixed text-lg rounded-full z-10 bottom-5 right-5 h-9 w-9 text-center bg-indigo-600 text-white leading-9 border-2 border-white"><i
      class="uil uil-arrow-up"></i></a>
  <!-- Back to top -->
</template>

<script>
export default {
  name: '',
  
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      if (window.pageYOffset > 300) {
        document.getElementById('back-to-top').style.display = 'block';
      } else {
        document.getElementById('back-to-top').style.display = 'none';
      }
    },
    topFunction() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }
}
</script>

<style></style>